"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnformattedBlock = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const UnformattedBlock = ({
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
  component: "pre"
  // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
  ,
  sx: {
    p: 2,
    backgroundColor: '#121212',
    borderRadius: 1,
    color: '#ccc',
    fontSize: '1.2rem',
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    textAlign: 'left',
    wordBreak: 'break-word',
    maxHeight: 800
  },
  dangerouslySetInnerHTML: {
    __html: String(children)
  }
});
exports.UnformattedBlock = UnformattedBlock;
